import React, { useEffect } from "react";
  
 
const AdminDashboard = (props) => {
    
 return (
    <div>
      <hr />
      
      <figure className="figure p-4 m-5">
           
         <h1> Wellcome to Admin Dashboard page (ReactJs)  </h1>  
         
      </figure>
    </div> 
  );
};
export default AdminDashboard;
